<div class="card container-fluid clsCardContainer">
  <h4 *ngIf="title" class="clsCard_Title">{{ title }}</h4>
  <ng-content></ng-content>
</div>
